import React, { useEffect, useState } from 'react';
// @ts-ignore
import styles from '../PatientProfileV2.module.scss';
import { UserEditedMeta } from './PatientProfileInformation';
import Text from '../../Base/Text/Text';
import { Theme } from '../../../Enums/Theme.enum';
import LinkButton from '../../Button/LinkButton';
import apiClient from '../../../Services/ApiClient';
import useNotification from '../../../Hooks/useNotification.hook';
import useApiClient from '../../../Modules/Base/Hooks/useApiClient';
import { useEffectAsync } from '../../../helpers';
import MediaViewerModal from '../../MediaViewer/MediaViewerModal';
import useTranslation from '../../../Hooks/useTranslation';
import { UserNumber } from '../../../graphql/graphql';

interface Props {
	user: UserEditedMeta;
	setIsLoading: (isLoading: boolean) => void;
	userNumber?: UserNumber;
}

const PatientProfileMouNumber: React.FC<Props> = ({ user, setIsLoading, userNumber }) => {
	const { showNotificationSuccess } = useNotification();
	const { displayError } = useApiClient();
	const [numberId, setNumberId] = useState(userNumber?.id);
	const [file, setFile] = useState(undefined);
	const { t } = useTranslation();

	useEffectAsync(async () => {
		await getUserNumber();
	}, []);

	useEffect(() => {
		setNumberId(userNumber?.id)
	}, [userNumber]);

	const getUserNumber = async () => {
		if (userNumber) {
			return;
		}

		if (user.partnerIdentifier) {
			setIsLoading(true);
			try {
				const result: any = await apiClient.get(
					'/user/number/user-number/' + user.partnerIdentifier,
					{},
				);
				if (result) {
					setNumberId(result?.data?.id);
				}
			} catch (e: any) {
				displayError(e);
			}
			setIsLoading(false);
		}
	};

	const handleSendMouNumberByEmail = async () => {
		if (numberId) {
			setIsLoading(true);
			try {
				await apiClient.get(
					'/user/number/' + numberId + '/send-email/' + user.email,
					{},
				);
				showNotificationSuccess({
					content: t(
						'component.patientProfileMouNumber.codeHasBeenSendToPatientsEmail',
					),
				});
			} catch (e: any) {
				displayError(e);
			}
			setIsLoading(false);
		}
	};

	const handleSendMouNumberBySms = async () => {
		if (numberId) {
			setIsLoading(true);
			try {
				await apiClient.get(
					'/user/number/' + numberId + '/send-sms/' + user.phoneNumber,
					{},
				);
				showNotificationSuccess({
					content: t(
						'component.patientProfileMouNumber.codeHasBeenSendToPatientsPhone',
					),
				});
			} catch (e: any) {
				displayError(e);
			}
			setIsLoading(false);
		}
	};

	const handlePrintMouNumber = async () => {
		if (numberId) {
			setIsLoading(true);
			try {
				const result: any = await apiClient.get(
					'/user/number/' + numberId + '/print/',
					{},
				);
				if (result) {
					setFile(result?.data?.url);
				}
			} catch (e: any) {
				displayError(e);
			}
			setIsLoading(false);
		}
	};

	return (
		<div className={styles.item}>
			<Text className={styles.name} tx='base.shared.mouNumber' firstUpper />
			<div className={styles.code}>{user.partnerIdentifier}</div>
			<LinkButton
				title='component.patientRegistrationStep2.printRegistrationCode'
				theme={Theme.BLUE}
				onClick={handlePrintMouNumber}
				className={'mr-3'}
			/>
			<LinkButton
				title='component.patientRegistrationStep2.sendCodeToEmail'
				theme={Theme.BLUE}
				onClick={handleSendMouNumberByEmail}
				className={'mr-3'}
			/>
			<LinkButton
				title='component.patientRegistrationStep2.sendCodeToPhone'
				theme={Theme.BLUE}
				onClick={handleSendMouNumberBySms}
				className={'mr-3'}
			/>
			{file && (
				<MediaViewerModal
					opened={!!file}
					onClose={() => setFile(undefined)}
					file={{
						id: '',
						download: file,
						preview: file,
						type: 'pdf',
						displayName: user.partnerIdentifier ?? '',
					}}
				/>
			)}
		</div>
	);
};

export default PatientProfileMouNumber;
